import { render, staticRenderFns } from "./BaseScrollContainer.vue?vue&type=template&id=28967a55&scoped=true&"
import script from "./BaseScrollContainer.vue?vue&type=script&lang=js&"
export * from "./BaseScrollContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollContainer.vue?vue&type=style&index=0&id=28967a55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28967a55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28967a55')) {
      api.createRecord('28967a55', component.options)
    } else {
      api.reload('28967a55', component.options)
    }
    module.hot.accept("./BaseScrollContainer.vue?vue&type=template&id=28967a55&scoped=true&", function () {
      api.rerender('28967a55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseScrollContainer.vue"
export default component.exports